import React from 'react';
import {
  Box,
  Typography,
  Button,
  Modal as MuiModal,
} from '@mui/material';
import MDButton from 'mdComponents/MDButton';

interface AlertProps {
  visible: boolean;
  title?: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel?: () => void;
}

const AddressNotBusinessVerifyModal: React.FC<AlertProps> = ({
  visible,
  title,
  message,
  confirmText = 'Okay',
  cancelText = 'Cancel',
  onConfirm,
  onCancel,
}) => {
  return (
    <MuiModal open={visible} onClose={() => {}}>
      <Box
        sx={{
          position: 'absolute' as const,
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: 4,
          width: 400,
          maxWidth: '90%',
          textAlign: 'center',
        }}
      >
        <Typography variant="h5" mb={1}>
          {title ?? 'Alert'}
        </Typography>

        <Typography variant="body2" mb={3}>
          {message}
        </Typography>

        <Box display="flex" justifyContent="flex-end" gap={2}>
          {onCancel && (
            <MDButton
                variant="outlined"
                color="secondary"
              onClick={onCancel}
            >
              {cancelText}
            </MDButton>
          )}          <MDButton color="info" onClick={onConfirm}>            {confirmText}
          </MDButton>

        </Box>
      </Box>
    </MuiModal>
  );
};

export default AddressNotBusinessVerifyModal;
